import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["controls", "category", "resource", "count"]

  declare readonly controlsTarget: HTMLElement
  declare readonly categoryTarget: HTMLSelectElement
  declare readonly resourceTargets: HTMLElement[]
  declare readonly countTarget: HTMLElement

  connect() {
    this.controlsTarget.hidden = false
    this.filter()
  }

  filter() {
    const category = this.categoryTarget.value
    this.resourceTargets.forEach(resource => {
      resource.hidden = !!category && resource.dataset.category !== category
    })
    const count = this.resourceTargets.filter(resource => !resource.hidden).length
    this.countTarget.textContent = this.countTarget.dataset.countTemplate?.replace("__COUNT__", String(count)) ?? ""
  }
}
